// =====================================================
// 📁 POSFiscalPrecinctSection.tsx
// =====================================================

import { useEffect } from 'react';

import { useSale } from '../../../../../hooks/sale/useSale';

import { useFiscalPrecinct } from '../../../../../hooks/fiscalPrecincts/useFiscalPrecinct';

import { useExportInvoiceSale } from '../../../../../hooks/sale/useExportInvoiceSale';

import POSSelectField from '../../../../POS/Fields/POSSelectField';

const POSFiscalPrecinctSection = () => {
  // =====================================================
  // 🔹 Hooks
  // =====================================================
  const { form } = useSale();

  const { handlerUpdateFiscalPrecinct } = useExportInvoiceSale();

  const {
    fiscalPrecinctDropdown,

    fetchFiscalPrecinctDropdown,
  } = useFiscalPrecinct();

  // =====================================================
  // 🔹 Effects
  // =====================================================
  useEffect(() => {
    fetchFiscalPrecinctDropdown('');
  }, []);

  // =====================================================
  // 🔹 Options
  // =====================================================
  const options = fiscalPrecinctDropdown.map((item) => ({
    value: item.id,

    label: item.name,
  }));

  // =====================================================
  // 🔹 Selected
  // =====================================================
  const selectedValue = form.exportInvoiceExtra?.fiscalPrecinct?.id ?? '';

  // =====================================================
  // 🎨 Render
  // =====================================================
  return (
    <div className="space-y-2">
      {/* ===================================================== */}
      {/* 🔹 Title */}
      {/* ===================================================== */}
      <div>
        <h4
          className="
            text-sm
            font-semibold
            text-black

            dark:text-white
          "
        >
          Recinto Fiscal
        </h4>

        <p
          className="
            mt-1

            text-xs
            text-body
          "
        >
          Selecciona el recinto fiscal correspondiente.
        </p>
      </div>

      {/* ===================================================== */}
      {/* 🔹 Select */}
      {/* ===================================================== */}
      <POSSelectField
        label="Recinto Fiscal"
        name="fiscalPrecinct"
        placeholder="Seleccione un recinto"
        value={selectedValue}
        options={options}
        iconKey="list"
        onChange={async (e) => {
          const selectedId = Number(e.target.value);

          if (!form?.id) {
            return;
          }

          await handlerUpdateFiscalPrecinct(form.id, selectedId);
        }}
      />
    </div>
  );
};

export default POSFiscalPrecinctSection;
